import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from '../Component/Footer';
import { useLanguage } from '../context/LanguageContext';
import Privacy from '../Component/Privacy';
import DesktopFooter from "../Component/Desktopfooter";
import Header from "../Component/header";
const Privacypage = () => {
    const { t } = useLanguage();
    return (
        <>
            <div className='text-Wrapper'>

            <Header/>
                <Box>
                    <Toolbar>
                        <Privacy />
                    </Toolbar>
                </Box>
            </div>
              <DesktopFooter/>
            <Footer />
        </>
    )
}

export default Privacypage